export default __webpack_public_path__ + "static/media/mt_portfolio-07.ff549377.png";